import React from "react"
import { SideTabs } from "shared/tabs"
import { SURVEY_BATCH_SETTINGS_TAB_SLUG, SURVEY_BATCH_SUBMISSIONS_TAB_SLUG } from "utils/tabSlugHelpers"
import SubmissionsContent from "./SubmissionsContent"
import SettingsContent from "./SettingsContent"

const SUBMISSIONS_TAB = {
  title: "Submissions",
  slug: SURVEY_BATCH_SUBMISSIONS_TAB_SLUG,
  TabContent: SubmissionsContent,
}

const SETTINGS_TAB = {
  title: "Settings",
  slug: SURVEY_BATCH_SETTINGS_TAB_SLUG,
  TabContent: SettingsContent,
}

const DEFAULT_SURVEY_BATCH_TABS = [
  SUBMISSIONS_TAB,
  SETTINGS_TAB,
]

const SurveyBatchTabs = () => (
  <SideTabs tabs={DEFAULT_SURVEY_BATCH_TABS} />
)

export default SurveyBatchTabs
